import { Box, Typography } from '@mui/material';

import QuestionnaireHeaderInfo from './QuestionnaireHeaderInfo';
import HeaderMetadata from './HeaderMetadata';
import { FORTA_BLUE, FORTA_WHITE } from '../../../../utils/colors';
import { formatEntityId } from '../../../../helpers';
import {
  HEADER_ID_BADGE_SX,
  HEADER_ID_TEXT_SX,
  HEADER_TITLE_AREA_SX,
  HEADER_TITLE_ROW_SX,
  HEADER_TITLE_SX,
  QUESTIONNAIRE_HEADER_WRAPPER_SX,
} from '../styles';

import type { HeaderTitleAreaProps } from '../types';

export default function HeaderTitleArea({
  author,
  bay,
  child,
  created,
  headerTreatmentPlanId,
  isMobile,
  pageId,
  pageIdPrefix,
  showHeaderMetadata,
  showQuestionnaireHeader,
  status,
  t,
  title,
}: HeaderTitleAreaProps) {
  if (showQuestionnaireHeader) {
    return (
      <Box sx={QUESTIONNAIRE_HEADER_WRAPPER_SX}>
        <QuestionnaireHeaderInfo
          title={title}
          pageId={pageId}
          pageIdPrefix={pageIdPrefix}
          created={created}
          author={author}
          child={child}
        />
      </Box>
    );
  }

  return (
    <Box sx={HEADER_TITLE_AREA_SX}>
      <Box sx={HEADER_TITLE_ROW_SX}>
        <Typography
          variant="h2"
          fontSize={{ xs: 18, sm: 26, md: 32 }}
          lineHeight={{ xs: 1.8, sm: 1.6, md: 1.5 }}
          fontWeight="bold"
          color={FORTA_WHITE}
          sx={HEADER_TITLE_SX}
        >
          {title}
        </Typography>
        {pageId ? (
          <Box sx={HEADER_ID_BADGE_SX}>
            <Typography
              sx={HEADER_ID_TEXT_SX}
              fontSize={isMobile ? 13 : 15}
              color={FORTA_BLUE.primary}
            >
              {formatEntityId(String(pageId), pageIdPrefix)}
            </Typography>
          </Box>
        ) : null}
      </Box>

      {showHeaderMetadata ? (
        <HeaderMetadata
          author={author}
          bay={bay}
          child={child}
          created={created}
          headerTreatmentPlanId={headerTreatmentPlanId}
          status={status}
          t={t}
        />
      ) : null}
    </Box>
  );
}
